import { useState, useEffect, useMemo } from 'react';

import { BREAKPOINT } from '@hero/constants';

function handleResize() {
  const isMobile = window.innerWidth <= BREAKPOINT.mobile.max;
  const isTablet = !isMobile && window.innerWidth <= BREAKPOINT.tablet.max;
  const isDesktop = (!isMobile || !isTablet) && window.innerWidth >= BREAKPOINT.desktop.min;

  return [isMobile, isDesktop, isTablet];
}

const [isMobile, isDesktop, isTablet] = handleResize();

export function useDevice() {
  const [device, setDevice] = useState({
    isMobile,
    isTablet,
    isDesktop
  });

  useEffect(() => {
    const _handleResize = () => {
      const [isMobile, isDesktop, isTablet] = handleResize();

      setDevice({
        isMobile,
        isDesktop,
        isTablet
      });
    };

    window.addEventListener('resize', _handleResize);
    return () => window.removeEventListener('resize', _handleResize);
  }, []);

  const memoizedDevice = useMemo(() => device, [device]);

  return memoizedDevice;
}
